import React,{useMemo,useEffect} from "react";
import { useForm,Controller } from "react-hook-form";
import ApplicationSelect from "../../Common/ApplicationSelect";
import { Form, Button, Input } from "antd";
const { TextArea } = Input;

const AddFaq = (props) =>{
    const {onSubmit,getApplicationId,applicationId} = props;
    const layout = {
        labelCol: {
            span: 5,
        },
        wrapperCol: {
            span: 12,
        },
    };
    const tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    const {
      control,
      handleSubmit,
      watch,
      formState: { errors,isSubmitted },
      getValues,      
      reset,
      setValue,
      form,
    } = useForm({
      defaultValues:{
        question:"",
        answer:"",
      }
    });
   
    const watchData = watch();

    const activeSubmit = useMemo(()=>{
      return getValues('question').length > 0 && getValues('answer').length > 0 ? false : true;
    },[watchData]);

    useEffect(()=>{
      reset();
      isSubmitted ?? reset();
    },[applicationId,isSubmitted]);

    return (
    <div >
        <Form.Item label="Solution" {...layout}><ApplicationSelect appChange={(e)=>getApplicationId(e)} applicationId={applicationId}/></Form.Item>
        {applicationId?(
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Form.Item label="Question" {...layout}>          
            <Controller
              render={({ field: { value, onChange,onBlur } }) => (
                  <Input onChange={onChange} onBlur={onBlur} value={value}/>
              )}
              name="question"
              control={control}
            />
          </Form.Item>
          <Form.Item label="Answer" {...layout}>          
            <Controller
              name="answer"
              control={control}
              
              render={({ field: { onChange,onBlur, value } }) => (
                  <TextArea rows={4} onChange={onChange} onBlur={onBlur} value={value}/>
              )}
            />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button htmlType="submit" type="primary" disabled={activeSubmit} >Submit</Button>
          </Form.Item>
          
          </form>

        ):null}
    </div>)

}

export default AddFaq;